/* PGJ promo: a countdown on product pages, and a one-time popup (email sign-up, or an announcement with a button).
   Both read the leads dashboard (pgj-leads): GET /api/promo and GET /api/popup. The popup's email goes through PGJLeads.send.
   Nothing here blocks the page. If the dashboard cannot be reached, the page simply shows no promo. */
(function () {
  'use strict';

  var endpoint = String(window.PGJ_LEADS_ENDPOINT || '').trim();
  if (!endpoint) return;
  var base = new URL(endpoint).origin;
  var store = window.PGJ_STORE === 'en' ? 'en' : 'id';
  var en = store === 'en';
  var DISMISS_KEY = 'pgj.popup.dismissed.' + store;

  var getJson = function (path) {
    return fetch(base + path, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  };
  var readDismissed = function () { try { return localStorage.getItem(DISMISS_KEY) || ''; } catch (e) { return ''; } };
  var writeDismissed = function (v) { try { localStorage.setItem(DISMISS_KEY, v); } catch (e) {} };
  var t = function (id, enText) { return en ? enText : id; };
  var el = function (tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };

  /* ---------- product countdown ---------- */
  // Days (only while more than a day is left), hours, minutes, seconds: each one is a block with its unit underneath.
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  function timeParts(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
    var u = en ? ['DAYS', 'HOURS', 'MIN', 'SEC'] : ['HARI', 'JAM', 'MENIT', 'DETIK'];
    return d ? [[d, u[0]], [pad(h), u[1]], [pad(m), u[2]], [pad(sec), u[3]]] : [[pad(h), u[1]], [pad(m), u[2]], [pad(sec), u[3]]];
  }

  function mountTimer(promo) {
    var box = el('div', 'pgj-promo-timer');
    box.setAttribute('role', 'status');
    var label = el('div', 'pgj-promo-label', promo.label);
    var clock = el('div', 'pgj-promo-clock');
    var ends = el('div', 'pgj-promo-ends');
    box.appendChild(label); box.appendChild(clock); box.appendChild(ends);

    var endsAt = Date.parse(promo.ends_at);
    var endsText = new Date(endsAt).toLocaleString(en ? 'en-GB' : 'id-ID', { timeZone: 'Asia/Jakarta', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
    ends.textContent = t('Berakhir ', 'Ends ') + endsText + ' WIB';

    var paint = function (parts) {
      clock.textContent = '';
      parts.forEach(function (p, i) {
        if (i) clock.appendChild(el('span', 'pgj-promo-sep', ':'));
        var cell = el('span', 'pgj-promo-cell');
        cell.appendChild(el('span', 'pgj-promo-num', String(p[0])));
        cell.appendChild(el('span', 'pgj-promo-unit', p[1]));
        clock.appendChild(cell);
      });
    };

    var tick = function () {
      var left = endsAt - Date.now();
      if (left <= 0) { box.remove(); return false; }
      paint(timeParts(left));
      return true;
    };
    if (!tick()) return;
    var timer = setInterval(function () { if (!tick()) clearInterval(timer); }, 1000);
    return box;
  }

  function placeTimer(promo) {
    var pdp = document.getElementById('pdp');
    if (!pdp) return false;
    var anchor = pdp.querySelector('.price-box');
    if (!anchor) return false;
    var box = mountTimer(promo);
    if (box) anchor.parentNode.insertBefore(box, anchor);
    return true;
  }

  function startProductTimer() {
    var handle = window.PGJ_PRODUCT_HANDLE;
    if (!handle) return;
    getJson('/api/promo?store=' + store + '&handle=' + encodeURIComponent(String(handle).toLowerCase())).then(function (res) {
      if (!res || !res.promo) return;
      var promo = res.promo;
      if (Date.parse(promo.ends_at) <= Date.now()) return;
      if (placeTimer(promo)) return;
      // the product view is drawn by script after load: wait for the price block to appear
      var pdp = document.getElementById('pdp') || document.body;
      var done = false;
      var observer = new MutationObserver(function () { if (!done && placeTimer(promo)) { done = true; observer.disconnect(); } });
      observer.observe(pdp, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, 15000);
    });
  }

  /* ---------- popup ---------- */
  var SKIP = /^\/(cart|checkout|account|login)/;

  function signUpForm(popup, body, dialog) {
    var form = el('form');
    var email = el('input');
    email.type = 'email'; email.required = true; email.autocomplete = 'email'; email.placeholder = t('Alamat email Anda', 'Your email address');
    email.setAttribute('aria-label', t('Alamat email', 'Email address'));
    var consentLabel = el('label', 'pgj-popup-consent');
    var consent = el('input'); consent.type = 'checkbox'; consent.required = true;
    consentLabel.appendChild(consent);
    consentLabel.appendChild(el('span', null, t('Saya setuju menerima email promo dari PGJ Watches. Bisa berhenti kapan saja.', 'I agree to receive promo emails from PGJ Watches. You can unsubscribe at any time.')));
    var error = el('div', 'pgj-popup-error'); error.setAttribute('role', 'alert');
    var submit = el('button', 'pgj-popup-submit', t('Daftar', 'Sign up')); submit.type = 'submit';
    form.appendChild(email); form.appendChild(consentLabel); form.appendChild(error); form.appendChild(submit);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      error.textContent = '';
      submit.disabled = true;
      var send = window.PGJLeads ? PGJLeads.send('newsletter', { email: email.value.trim() }, { consent: { marketing: true } }) : Promise.resolve(null);
      send.then(function (receipt) {
        if (!receipt) { error.textContent = t('Maaf, belum bisa menyimpan. Coba lagi sebentar.', 'Sorry, we could not save that yet. Please try again shortly.'); submit.disabled = false; return; }
        body.textContent = '';
        body.appendChild(el('h2', null, t('Terima kasih', 'Thank you')));
        body.appendChild(el('p', null, t('Kami kirim promo terbaru ke email Anda.', 'We will send the latest offers to your inbox.')));
        writeDismissed(popup.version);
        setTimeout(function () { dialog.close(); }, 2200);
      });
    });
    body.appendChild(form);
    if (popup.cta_url) {
      var link = el('a', 'pgj-popup-link', popup.cta_label || t('Lihat koleksi', 'View the collection'));
      link.href = popup.cta_url;
      body.appendChild(link);
    }
  }

  function announcement(popup, body, dialog) {
    var button = el('a', 'pgj-popup-submit', popup.cta_label);
    button.href = popup.cta_url;
    // the page is leaving, so the close event will not run: remember the popup here
    button.addEventListener('click', function () { writeDismissed(popup.version); });
    body.appendChild(button);
  }

  function buildPopup(popup) {
    var dialog = el('dialog', 'pgj-popup');
    dialog.setAttribute('aria-labelledby', 'pgj-popup-title');

    var close = el('button', 'pgj-popup-close', '×'); close.type = 'button'; close.setAttribute('aria-label', t('Tutup', 'Close'));
    close.addEventListener('click', function () { dialog.close(); });
    dialog.appendChild(close);

    if (popup.image_url) {
      var img = el('img', 'pgj-popup-image'); img.src = popup.image_url; img.alt = ''; img.decoding = 'async';
      dialog.appendChild(img);
    }

    var body = el('div', 'pgj-popup-body');
    var title = el('h2', null, popup.title); title.id = 'pgj-popup-title';
    body.appendChild(title);
    if (popup.body) body.appendChild(el('p', null, popup.body));
    dialog.appendChild(body);

    if (popup.kind === 'announce') announcement(popup, body, dialog);
    else signUpForm(popup, body, dialog);

    dialog.addEventListener('close', function () { writeDismissed(popup.version); dialog.remove(); });
    return dialog;
  }

  function startPopup() {
    if (SKIP.test(location.pathname)) return;
    getJson('/api/popup?store=' + store).then(function (res) {
      var popup = res && res.popup;
      if (!popup || readDismissed() === popup.version) return;
      var show = function () {
        var dialog = buildPopup(popup);
        document.body.appendChild(dialog);
        try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
      };
      var delay = Math.max(0, Number(popup.delay_seconds) || 0) * 1000;
      setTimeout(function () { if (!document.querySelector('dialog.pgj-popup')) show(); }, delay);
    });
  }

  var start = function () { startProductTimer(); startPopup(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
